import {PRODUCTS} from "../constant/PRODUCTS";

const selectedCoverages = (options) => {
  let coverages = []
  PRODUCTS.forEach(function (key, value) {
    if (options[key] && options[key].value) {
      coverages.push(key)
    }
  })
  return coverages
}
export default selectedCoverages